import { render } from "./errorLayout.vue?vue&type=template&id=32cb5429"
import script from "./errorLayout.vue?vue&type=script&lang=js"
export * from "./errorLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/NEW-Master-integrated-sugang-admin-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__